import { Box, Flex, Text, Button as ChakraButton } from "@chakra-ui/react";

export default function PreviewBanner() {
  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={9999}
      bg="blue.500"
      color="white"
      py={2}
      px={4}
    >
      <Flex justify="center" align="center" gap={4}>
        <Text fontSize="sm" fontWeight="bold">
          Preview Mode
        </Text>
        <ChakraButton
          size="xs"
          variant="outline"
          colorScheme="whiteAlpha"
          as="a"
          href="/api/exit-preview"
        >
          Exit Preview
        </ChakraButton>
      </Flex>
    </Box>
  );
}
